import BaseService from "../baseService";
class CodigosServicoG4 extends BaseService {
    constructor(id) {
        const resource = "rpa-codigo-servico-g4";
        let relationship = {};
        super(id, relationship, resource);
    }
}

export default (id) => new CodigosServicoG4(id);
